@if (message() && !toast()) {
<div class="alert alert-success" role="alert">
  {{ message() | translate }}
</div>
}
